/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_Errors_DescInputs */

const en_privacy_section_2_item_errors_desc = /** @type {(inputs: Privacy_Section_2_Item_Errors_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technical error information, including IP addresses and browser details, collected via Sentry for debugging purposes`)
};

const lv_privacy_section_2_item_errors_desc = /** @type {(inputs: Privacy_Section_2_Item_Errors_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tehniska kļūdu informācija, ieskaitot IP adreses un pārlūka detaļas, ko apkopo Sentry atkļūdošanas nolūkos`)
};

/**
* | output |
* | --- |
* | "technical error information, including IP addresses and browser details, collected via Sentry for debugging purposes" |
*
* @param {Privacy_Section_2_Item_Errors_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_errors_desc = /** @type {((inputs?: Privacy_Section_2_Item_Errors_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_Errors_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_errors_desc(inputs)
	return en_privacy_section_2_item_errors_desc(inputs)
});